// newOrder/components/inputFields/TextInput.js
import React, { useState, forwardRef } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import styles from './styles.js';

const TextInput = forwardRef((props, ref) => {
    // Forward keyboard events if needed
    const handleKeyDown = (e) => {
        if (props.onKeyDown) {
            props.onKeyDown(e);
        }
    };

    function renderLabel() {
        // Apply labelWrapper style which includes flex centering
        return (
            <Grid item xs={props.labelSize} className={"fieldLabel"} style={props.color === 'secondary' ? styles.labelWrapperSecondary : styles.labelWrapper}>
                <Typography variant='subtitle1' style={props.color === 'secondary' ? styles.labelSecondary : styles.label}>{props.label}</Typography>
            </Grid>
        );
    }

    // Determine styles based on multiline prop
    const textFieldStyle = {
      ...styles.formControlTextfield,
      // Apply auto height for multiline, 40px for single line
      height: props.multiline ? 'auto' : '40px',
      // If minHeight is passed (from MemoInput), use it for multiline
      minHeight: props.multiline && props.style?.minHeight ? props.style.minHeight : (props.multiline ? 'auto' : '40px')
    };

    const inputPropsStyle = {
        // Apply auto height for multiline, 40px for single line
       height: props.multiline ? 'auto' : '40px',
       // If minHeight is passed (from MemoInput's InputProps), use it for multiline
       minHeight: props.multiline && props.InputProps?.style?.minHeight ? props.InputProps.style.minHeight : (props.multiline ? 'auto' : '40px')
    };


    return (
        <>
        {props.labelSize > 0 &&
            <Grid
                container
                direction="row"
                justifyContent="stretch"
                alignItems="stretch" // Keep stretch here
                style={styles.TextInputGrid}
                spacing={0}
            >
                {props.labelSize && props.labelSize > 0 && renderLabel()}
                <Grid item xs={12 - props.labelSize}>
                    <TextField
                        editable={false}
                        variant={props.variant ? props.variant : "outlined"}
                        size="small"
                        style={textFieldStyle} // Use dynamic style
                        fullWidth
                        margin='none'
                        inputRef={ref || props.inputRef}
                        onKeyDown={handleKeyDown}
                        data-panel-type={props['data-panel-type']}
                        {...props}
                        label=''
                        InputProps={{ ...props.InputProps, style: inputPropsStyle }} // Merge styles
                    />
                </Grid>
            </Grid>
        }

        {props.labelSize == 0 &&
            <Grid
                container
                direction="row"
                justifyContent="stretch"
                alignItems="stretch"
                style={styles.root}
                spacing={0}
            >
                <TextField
                    editable={false}
                    variant={props.variant ? props.variant : "outlined"}
                    size="small"
                    style={textFieldStyle} // Use dynamic style
                    fullWidth
                    margin='none'
                    inputRef={ref || props.inputRef}
                    onKeyDown={handleKeyDown}
                    data-panel-type={props['data-panel-type']}
                    {...props}
                    label={props.label}
                    InputProps={{ ...props.InputProps, style: inputPropsStyle }} // Merge styles
                />
            </Grid>
        }
        </>
    );
});

export default TextInput;